<template>
  <div class="wrap">
    <mescroll-vue class="mescroll" :class="{'mescroll1':isIos}" ref="mescroll" :down="mescrollDown" :up="mescrollUp"
                  @init="mescrollInit">
      <!--Banner-->
      <banner :data="bannerList"></banner>
      <!-- 菜单按钮 -->
      <div class="menuBox">
        <van-grid :column-num="5" :border="false">
          <van-grid-item v-for="(item,i) in menuList" :key="i" @click="doMenu(item)">
            <img slot="icon" class="menu_icon" :src="item.icon"/>
            <div slot="text" class="menu_text f14">{{ item.name }}</div>
          </van-grid-item>
        </van-grid>
      </div>
      <!--公告-->
      <div class="noticeBox flex flex_start" @click="$router.push('/common/announcement')">
        <div class="icon">
          <img src="https://m.whsq365.com/wohuisq/static/wxapp/image/common/wohuitoutiao.png"/>
        </div>
        <div class="line"></div>
        <div class="textBox">
          <van-swipe :vertical="true" :show-indicators="false" :autoplay="3000" :duration="1000" style="height:32px;">
            <van-swipe-item v-for="(item, i) in announcementList" :key="i" style="height: 32px;">
              <div class="f12" style="height: 32px;line-height: 32px;overflow: hidden;">{{ item.title }}</div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
      <!-- 1111等活动 -->
      <!-- <div class="activityBox flex_between flex_wrap">
        <div class="item" v-for="(item,i) in activityList" :key="i" @tap="doAcitivty(item)">
          <image :src="item.image" mode="scaleToFill"></image>
        </div>
      </div> -->
      <!-- 商品列表 -->
      <div class="white ">
        <div class="pub_center" style="margin: 18px 0 10px;">
          <img src="https://m.whsq365.com/wohuisq/static/wxapp/image/common/jingxuanzhuanqu.png" mode="widthFix"
               style="width: 60%"/>
        </div>
        <div class="list" id="listId">
          <div v-for="(item, i) in dataList" :key="i" class="white">
            <goodsItem :item="item" layoutType="0" source="PDD"></goodsItem>
          </div>
        </div>
      </div>
    </mescroll-vue>
  </div>
</template>

<script>
import {eleme, indexInfo, jdWaiMai, meituan, pddShouYeList} from "../../../api/commonV2";

export default {
  data() {
    return {
      bannerList: [], //banner
      menuList: [], //菜单
      announcementList: [], //公告
      activityList: [], //双11活动等
      dataList: [], // 精选拼多多产品列表
      listId: '' //拼多多翻页必传
    }
  },
  created() {
    this.getIndexInfo()
  },
  methods: {
    // 首页数据
    getIndexInfo() {
      let data = {
        type: "app"
      }
      indexInfo(data).then(res => {
        if (res.result === '0') {
          this.bannerList = res.bannerList
          this.menuList = res.categoryList //菜单按钮
          this.announcementList = res.announcementList //公告
          this.activityList = res.activityList //双11活动
        }
      })
    },
    mescrollInit(mescroll) {
      // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
      this.mescroll = mescroll
      // 锁定下拉刷新
      this.mescroll.lockDownScroll()
    },
    upCallback(val) {
      let data = {
        pageNo: val.num,
        pageSize: val.size,
        listId: this.listId
      }
      pddShouYeList(data).then(res => {
        if (res.result === '0') {
          if (val.num === 1) {
            this.dataList = []
          }
          this.listId = res.listId
          res.dataList ? this.dataList = this.dataList.concat(res.dataList) : ''
          this.mescroll.endByPage(res.dataList.length, res.totalPage)
        }
      }, err => {
        this.mescroll.endErr()
      })
    },
    // 路由跳转
    doMenu(item) {
      var type = item.type;
      var name = item.name;
      console.log("doMenu:type=" + type + ",name=" + name)
      switch (type) {
        case "1": //我惠云店
          this.$router.push("/whyd");
          return;
        case "2": //C2F优选
          this.$router.push("/whyd/ydZone?zoneType=2&zoneName=" + name);
          return;
        case "3": //惠康优品
          this.$router.push("/whyd/ydZone?zoneType=3&zoneName=" + name);
          return;
        case "4": //惠拼优选
          this.$router.push("/hpyx");
          return;
        case "5": //C2F留言
          this.$router.push("/whyd/c2fLiuYan");
          return;
        case "6": //天猫
          this.$router.push("/union/tao/tmall");
          return;
        case "7": //淘宝
          this.$router.push("/union/tao/taobao");
          return;
        case "8": //京东
          this.$router.push("/union/jd/index");
          return;
        case "9": //聚划算
          this.$router.push("/union/tao/juhuasuan");
          return;
        case "10": //拼多多
          this.$router.push("/union/pdd/index");
          return;
        case "11": //饿了么
          if (this.checkLogin()) {
            this.eleme();
          }
          return;
        case "12": //抖券换成京东外卖
          if (this.checkLogin()) {
            this.jdWaiMai() //京东外卖
          }
          return
        case "13": //酒店
          if (this.checkLogin()) {
            this.meituan('1') //美团酒店
          }
          return;
        case "14": //美团
          if (this.checkLogin()) {
            this.meituan('0') //外卖
          }
          return;
        case "15": //新手指南
          this.$router.push("/common/college");
          return;
        default:
          return;
      }
    },
    //饿了么外卖
    eleme() {
      let data = {}
      eleme(data).then(res => {
        if (res.result === '0') {
          res.data.forEach(item => {
            if (item.type === '0') {
              window.location.href = item.h5Url;
            }
          })
        }
      }, err => {
      })
    },
    //美团：type=0 外卖，type=1酒店
    meituan(type) {
      let data = {}
      meituan(data).then(res => {
        if (res.result === '0') {
          res.data.forEach(item => {
            //type判断
            if (item.type === type) {
              window.location.href = item.h5Url;
            }
          })
        }
      }, err => {
      })
    },
    //京东外卖
    jdWaiMai() {
      let data = {}
      jdWaiMai(data).then(res => {
        if (res.result === '0') {
          res.data.forEach(item => {
            if (item.type === '0') {
              window.location.href = item.h5Url;
            }
          })
        }
      }, err => {
      })
    },
    checkLogin() { //检测是否登录
      let uid = localStorage.getItem('uid') || ''
      if (!uid) { //未登录
        this.$router.push('/user/login')
        return false
      } else {
        return true
      }
    },
  }
}
</script>

<style scoped lang="less">
.wrap {
  background: #FFF;
}

.navbar {
  padding: 0 10px;

  .icon {
    width: 24px;
    height: 24px;
  }

  .search {
    margin: 0 10px;
  }
}

.menuBox {
  .menu_icon {
    width: 50px;
    height: 50px;
  }

  /deep/.van-grid-item__content {
    padding: 5px;
  }
}

.popupCommand {

  .title {
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-bottom: 1px solid #D1D1D1;
  }

  .text {
    line-height: 25px;
    padding: 10px;
  }

  .btn {
    text-align: center;
    display: block;
    line-height: 30px;
    margin: 5px 10px;
  }
}

.noticeBox {
  background: #F0F0F0;
  padding: 0 10px;

  .icon {
    width: 50px;

    img {
      width: 50px;
      height: 12px;
    }
  }

  .line {
    display: inline-block;
    width: 1px;
    height: 16px;
    margin-right: 5px;
    margin-left: 5px;
    background: #c0c0c0;
  }

  .textBox {
    width: 100%;
  }
}

.activityBox {
  width: 355px;
  margin: 5px auto;

  .item {
    width: 175px;

    img {
      width: 175px;
      border-radius: 5px;
      height: 75px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/tabBar/home/fine.vue